import Color from 'color';
import { BrandTheme } from 'api/account';

export const getTheme = (
  value: {
    brandColor?: string;
    sideNavBg?: string;
  } = {},
): BrandTheme => {
  let { brandColor } = value;
  let { sideNavBg } = value;
  let brandHoverColor = '#0043ce';
  let brandColorInRgb = '15, 98, 254';
  const defaultBrandColor = '#0f62fe';
  const defaultSideNavBg = '#161616';

  if (brandColor) {
    const color = Color(brandColor);

    const result = color.darken(0.2);

    brandHoverColor = result.hex();
    brandColorInRgb = `${result.rgb().array()[0].toFixed(0)}, ${result
      .rgb()
      .array()[1]
      .toFixed(0)}, ${result.rgb().array()[2].toFixed(0)}`;
  } else {
    brandColor = defaultBrandColor;
  }

  let sideNavText = '#ffffff';

  if (sideNavBg) {
    const result = Color(sideNavBg);

    if (result.isLight()) {
      sideNavText = '#000000';
    }
  } else {
    sideNavBg = defaultSideNavBg;
  }

  return {
    brandColor,
    sideNavBg,
    sideNavText,
    brandHoverColor,
    brandColorInRgb,
  };
};
